import styles from './Logo.module.scss';
import { Link } from 'react-router-dom';
import { Image } from 'antd';
import logo from '../../../../assets/images/logo.svg';
import { useSelector } from 'react-redux';

const Logo = () => {
    const collapsed = useSelector(state => state.siderMenu.isSiderCollapsed);

    return (
        <Link className={styles.logoContainer} to={'#'}>
            <Image src={logo} preview={false} />
            <div className={styles.logoTitle}>{collapsed ? 'MT' : 'Management Tool'}</div>
        </Link>
    );
};

export default Logo;
